import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { FormExportToCSV } from './form';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { ACCESS_CODE } from '../../../constants/define/translation';
import { appStyles, selectSelector } from '../../../styles';

interface AccessCodeModalExportProps {
  isOpenModal: boolean;
  onClose: () => void;
  purposeList?: any[];
}

export const AccessCodeModalExport = (props: AccessCodeModalExportProps) => {
  const { t } = useTranslation(ACCESS_CODE);
  const { isOpenModal, onClose, purposeList } = props;

  return (
    <StyledModal
      title={<TitleModal title={t('header.buttonExport')} />}
      centered
      visible={isOpenModal}
      width={630}
      footer={null}
      onCancel={() => {
        onClose();
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormExportToCSV onClose={onClose} purposeList={purposeList} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .btn-wrap {
    text-align: center;
  }

  .btn-generate-code {
    width: 270px;
    margin: 2rem;
  }

  .ant-form-item-label {
    font-weight: bold;
  }

  .form-content {
    padding: 1.5rem 1.5rem 3.5rem;
  }

  .btn-submit-generate-access-code,
  .btn-submit-export-access-code {
    position: absolute;
    bottom: 1rem;
    right: 3rem;
  }

  & input[type='text'],
  & input[type='number'] {
    ${appStyles.inputStyle}
  }

  .ant-select-selector {
    height: 36px !important;
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      padding: 2px 18px 2px 0;
    }
  }

  ${selectSelector}

  .title-primary {
    padding: 0.4rem;
  }

  .ant-form-item {
    margin-bottom: 8px;
  }

  .input-duration {
    margin-top: -20px;
    margin-bottom: 0;
  }

  .input-invisibility {
    visibility: hidden;
  }
`;
